import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CustomFormFieldsModalComponent } from './components/custom-form-fields-modal/custom-form-fields-modal.component';



@NgModule({
    declarations: [CustomFormFieldsModalComponent],
    exports: [CustomFormFieldsModalComponent],
    imports: [CommonModule, MatInputModule, MatDatepickerModule, ReactiveFormsModule, MatCheckboxModule, MatSelectModule, MatExpansionModule, FontAwesomeModule],
})
export class CustomFormFieldsModule {}
